'use client';

import React__default from 'react';

var IconSuccess = function () {
    return (React__default.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M9.9999 0.399902C4.6983 0.399902 0.399902 4.6983 0.399902 9.9999C0.399902 15.3015 4.6983 19.5999 9.9999 19.5999C15.3015 19.5999 19.5999 15.3015 19.5999 9.9999C19.5999 4.6983 15.3015 0.399902 9.9999 0.399902ZM15.3655 8.1655L9.3175 14.2135C9.1671 14.3639 8.9639 14.4479 8.7519 14.4479C8.5399 14.4479 8.3359 14.3639 8.1863 14.2135L5.4239 11.4511C5.1111 11.1383 5.1111 10.6327 5.4239 10.3199C5.7367 10.0071 6.2423 10.0071 6.5551 10.3199L8.7519 12.5167L14.2343 7.0343C14.5471 6.7215 15.0527 6.7215 15.3655 7.0343C15.6783 7.3471 15.6783 7.8527 15.3655 8.1655Z", fill: "#6FB920" })));
};

export { IconSuccess as default };
//# sourceMappingURL=IconSuccess.js.map
